import { Page } from '@/components/Page';
import { useTranslation } from 'react-i18next';
import { ProjectList } from '@/views/Projects.List';
import { useGetProjectsQuery, useUserContextSelector } from '@/redux';
import { Typography } from 'antd';
import classes from './ProjectListPage.module.scss';

export const ProjectsListPage = () => {
  const { t } = useTranslation();
  const { data: projectsData } = useGetProjectsQuery();
  const [name] = useUserContextSelector((x) => [x.name]);

  return (
    <Page htmlTitle={t('projects.title')}>
      <Page.Body>
        <Page.Card className={classes.page}>
          <Typography.Title className={classes.greeting} level={3}>
            Happy to see you, {name.split(' ')?.[0]}!
          </Typography.Title>
          {projectsData ? <ProjectList projectsListData={projectsData} /> : null}
        </Page.Card>
      </Page.Body>
    </Page>
  );
};
